import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MessageCircle, Phone, Clock } from 'lucide-react';
import SEOHead from '../seo/SEOHead';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import ContactForm from '../homepage/ContactForm';
import './Pages.css';

const ContactPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Contact Us - GymsSync | Get in Touch"
        description="Contact GymsSync for demo, support, or inquiries. WhatsApp: +91 8962327749. Schedule a meeting to see our gym management software in action."
        keywords="contact gymsync, contact gymssync, gym software demo, gym management support, gymsync contact, gym software support, gym management software contact, gym software demo request, gym management software help, gym software customer support, gym management software inquiry, gym software sales, gym management software consultation"
        ogUrl={typeof window !== 'undefined' ? window.location.href : ''}
        canonicalUrl={typeof window !== 'undefined' ? `${window.location.origin}/contact` : ''}
      />
      <Navbar />
      <div className="page-container">
        <div className="page-header">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="page-title"
          >
            Get in Touch
          </motion.h1>
          <p className="page-subtitle">
            Interested in seeing GymsSync in action? Contact us to schedule a demo meeting!
          </p>
        </div>

        <div className="page-content">
          <div className="contact-grid-page">
            <motion.a
              href="https://wa.me/918962327749?text=Hi, I'm interested in GymsSync gym management software. Can we schedule a demo meeting?"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card-page whatsapp"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <MessageCircle size={64} />
              <h3>WhatsApp</h3>
              <p>+91 8962327749</p>
              <span className="contact-action">Send Message →</span>
            </motion.a>
            
            <motion.a
              href="tel:+918962327749"
              className="contact-card-page phone"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              whileHover={{ scale: 1.05 }}
            >
              <Phone size={64} />
              <h3>Call Us</h3>
              <p>+91 8962327749</p>
              <span className="contact-action">Call Now →</span>
            </motion.a>
            
            <motion.div
              className="contact-card-page email"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              <Clock size={64} />
              <h3>Schedule Demo</h3>
              <p>Contact us to book a meeting</p>
              <span className="contact-action">Available on request</span>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            style={{ marginTop: '4rem' }}
          >
            <ContactForm />
          </motion.div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;

